import { UserSelect } from "./User";
export var ReportToBoardIncludes = {
    board: true,
    user: {
        select: UserSelect
    },
};
//# sourceMappingURL=ReportToBoard.js.map